/**
 * Словари по языкам (DEV-2503). Во входном чанке их нет: каждый язык — свой чанк,
 * и в нём только этот язык (суффикс ?lang= разбирает tool/vite-locale-lang.ts).
 * Тестам vitest.config.ts подставляет вместо этого модуля catalog.eager.ts.
 */
import type { Locale, MessageSchema } from './locales'

const loaders = {
  ru: () => import('./locales/index.ts?lang=ru'),
  en: () => import('./locales/index.ts?lang=en'),
  vn: () => import('./locales/index.ts?lang=vn'),
}

export const initialMessages = {} as Record<Locale, MessageSchema>

export const loadMessages = async (locale: Locale): Promise<MessageSchema> =>
  (await loaders[locale]()).messages[locale]
